<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-step`]" width="1em" height="1em" v-bind="$attrs"><rect x="1.919" y="3.498" width="20.162" height="17.004" rx="4" stroke="#165DFF" stroke-width="1.66" stroke-linejoin="round"/><path d="M15.5168 8.84961C15.9752 8.84961 16.3469 9.22129 16.3469 9.67969V11.166H17.84C18.2984 11.1661 18.6701 11.5377 18.6701 11.9961C18.6699 12.4543 18.2982 12.8261 17.84 12.8262H16.3469V14.3184C16.3468 14.7767 15.9752 15.1484 15.5168 15.1484C15.0585 15.1483 14.6867 14.7766 14.6867 14.3184V12.8262H13.2014C12.7431 12.8262 12.3715 12.4543 12.3713 11.9961C12.3713 11.5377 12.743 11.166 13.2014 11.166H14.6867V9.67969C14.6867 9.22137 15.0585 8.84974 15.5168 8.84961ZM9.21503 11.1689C9.6732 11.1692 10.0451 11.5408 10.0451 11.999C10.045 12.4572 9.67316 12.8288 9.21503 12.8291H6.16034C5.70233 12.8287 5.33033 12.4571 5.33026 11.999C5.33026 11.5409 5.70229 11.1694 6.16034 11.1689H9.21503Z" :fill="useCurrentColor ? 'currentColor' : '#00BBD8'"/></svg>
</template>
<script>

export default {
  name: 'IconColorStep',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
